import axios from 'axios';
import AppSettings from '../../../../core/AppSettings';

export const getHomeCarouselData = ()=>{
    const url = "/wcs/resources/store/" + AppSettings.storeId + "/espot/Homepage_Hero";
    return axios.get(url).then(response=>response.data);
};